export default {"src":"/_next/static/image/public/images/ic_vm_patient_portal.dc8151bb67a72bde116964a8eac0aed4.svg","height":18,"width":20};